import React, { BaseSyntheticEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IOption } from '../../../common/common.types'
import SingleSelectPage from '../../../components/singleSelectPage/SingleSelectPage.component'
import { useTranslation } from 'react-i18next'
import {
  savePatientMedications,
  setName,
  setShowSingleSelectLookup,
  setCurrentMedication,
} from '../store/patientMedications.actions'
import { getPatientMedicationsSelector } from '../selectors'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import { getPatientMedicationsOptionsSelector } from '../../options/selectors'
import { goBack } from '../../../utilities/navigation.util'

const MedicationSearch: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const medicationState = useSelector(getPatientMedicationsSelector)
  const { patientMedication, areOptionsLoading } = medicationState
  const medicationOptionsState = useSelector(getPatientMedicationsOptionsSelector)
  const { medicationsOptions, medicationsCommonOptions } = medicationOptionsState
  const { isTablet } = useDeviceMetrics()

  const onBackClick = () => {
    if (isTablet) {
      dispatch(setShowSingleSelectLookup(false))
    } else {
      goBack()
    }
    dispatch(setCurrentMedication(patientMedication))
  }

  const setSelectedName = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    dispatch(setName(option, patientMedication))
    dispatch(setCurrentMedication(patientMedication))
    onBackClick()
    dispatch(savePatientMedications())
  }

  return (
    <SingleSelectPage
      selectedOption={patientMedication?.name}
      options={medicationsOptions}
      action={setSelectedName}
      backAction={onBackClick}
      dividerText={t('patientMedications.tapToAddMedicationToCurrentPatient')}
      commonOptions={medicationsCommonOptions}
      loading={areOptionsLoading}
      listHeader={'Current Medications'}
      hidePageTag={isTablet}
      showHeader={!isTablet}
    />
  )
}

export default MedicationSearch
